import { Box, Button, Chip, Option, Select, Stack } from "@mui/joy";
import { Paper, Typography, Zoom } from "@mui/material";
import { useEffect, useState } from "react";
import { centrado } from "../utils/Estilos";
import { theme2 } from "../theme";

import tienda from "../assets/banner/bannercursos.jpeg";
import { useNavigate } from "react-router-dom";
import { Cargando } from "../utils/Cargando";
import no from "../assets/image/no.png";
import { Helmet } from "react-helmet";

export const Cursos = () => {
  const [productos, setProductos] = useState(null);

  const navigate = useNavigate();

  const [imagenes2, setImagenes2] = useState([]);

  useEffect(() => {
    cargar();
  }, []);

  function cargarImagen(etiqueta) {
    let ind = imagenes2.findIndex((val) => val?.name === etiqueta);
    if (ind >= 0) {
      return imagenes2[ind].img;
    }
    return null;
  }

  async function cargarImagenes2(productos) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    for (const el of productos) {
      if (el?.fotoId) {
        await fetch(
          "https://portal.publimed.net/api/v1/Attachment/file/" + el?.fotoId,
          requestOptions,
        )
          .then((response) => response.blob())
          .then((result) => {
            setImagenes2((prev) => [
              ...prev,
              { img: URL.createObjectURL(result), name: el?.fotoId },
            ]);
          })
          .catch((error) => console.error(error));
      }
    }
  }

  function cargar() {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `https://portal.publimed.net/api/v1/CCurso?searchParams={"where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"}],
      "select": ["id","name","deleted","description","precio","descuento","preciodescuento","codigoCurso","fotoId","fotoName"]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setProductos(res.list);
        cargarImagenes2(res.list);
      })
      .catch((error) => {
        console.error(error);
        setProductos([]);
      });
  }

  return (
    <Box sx={{ ...centrado, width: "100%", flexWrap: "wrap" }}>
      <Helmet>
        <title>{"Publimed Store - Tienda"}</title>
      </Helmet>
      <Cargando open={!productos} />
      <Box
        sx={{
          backgroundImage: "url(" + tienda + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
          width: "100%",
        }}
      />
      {productos?.length !== 0 && (
        <>
          <Box sx={{ width: "90%", ...centrado, flexWrap: "wrap" }}>
            {productos?.map((val) => (
              <Zoom in={val?.id?.length > 0} key={val?.id}>
                <Box sx={{ padding: "10px", width: "280px" }}>
                  <Paper
                    elevation={2}
                    sx={{
                      ":hover": {
                        boxShadow: 20,
                      },
                      padding: "20px",
                      border: 1,
                      borderRadius: "25px",
                      borderColor: theme2.palette.primary.main,
                    }}
                  >
                    <Stack spacing={2}>
                      <Box
                        sx={{
                          height: "0px",
                          padding: "0px",
                          margin: "0px",
                          textAlign: "right",
                        }}
                      >
                        {val?.descuento === "SI" && (
                          <Chip
                            sx={{ marginBottom: "-40px", marginRight: "5px" }}
                            color="danger"
                            variant="solid"
                          >
                            {" "}
                            Oferta
                          </Chip>
                        )}
                      </Box>

                      {val?.fotoId && (
                        <img
                          alt={"fotoProducto"}
                          src={cargarImagen(val?.fotoId) ?? no}
                          width={"100%"}
                        />
                      )}

                      {val?.imagen && !val?.fotoId && (
                        <img
                          alt={"fotoProducto"}
                          src={"https://publimed.net/iconos/" + val?.imagen}
                          width={"100%"}
                        />
                      )}
                      <Typography
                        fontWeight={"bold"}
                        sx={{
                          height: "70px",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          fontSize: "15px",
                          WebkitLineClamp: 3,
                          textOverflow: "ellipsis",
                        }}
                      >
                        {val?.name}
                      </Typography>
                      <Box>
                        {val?.descuento === "SI" && (
                          <Chip
                            color="neutral"
                            sx={{ textDecoration: "line-through" }}
                          >
                            {"$ " + parseFloat(val?.preciodescuento).toFixed(2)}
                          </Chip>
                        )}
                        <Chip color="success">
                          {"$ " + parseFloat(val?.precio).toFixed(2)}
                        </Chip>
                      </Box>
                      <Button
                        onClick={() => {
                          navigate("/curso/" + val?.id);
                        }}
                        variant="solid"
                      >
                        <Typography
                          fontWeight={"bold"}
                          sx={{ textAlign: "center" }}
                        >
                          Ver más
                        </Typography>
                      </Button>
                    </Stack>
                  </Paper>
                </Box>
              </Zoom>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};
